'use strict';

/*global services*/

function initialize($wrapper) {
    $wrapper.find('.delete-confirmation').DeleteConfirmation();
    $wrapper.find('.date-picker').datepicker({ language: 'cs', autoclose: true, format: 'dd.mm.yyyy' });
    $wrapper.find('.rating-icons-wrapper').rating();

    $wrapper.find('.carousel-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        asNavFor: '.carousel-thumbnail'
    });
    $wrapper.find('.carousel-thumbnail').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.carousel-slider',
        dots: false,
        infinite: false,
        focusOnSelect: true,
        arrows: true,
        swipe: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });

    $wrapper.find('.magnific-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        closeOnContentClick: false,
        closeBtnInside: false,
        mainClass: 'mfp-with-zoom mfp-img-mobile',
        image: {
            verticalFit: true,
            titleSrc: function (item) {
                return item.el.attr('title') + ' &middot; <a class="magnific-image-source-link" href="' + item.el.attr('href') + '" target="_blank">' + services.get('translator').trans('ImageSource') + '</a>';
            }
        },
        gallery: {
            enabled: true,
            tPrev: services.get('translator').trans('GalleryPrevieous'),
            tNext: services.get('translator').trans('GalleryNext'),
            tCounter: '%curr% ' + services.get('translator').trans('of') + ' %total%'
        },
        zoom: {
            enabled: true,
            duration: 300, // don't foget to change the duration also in CSS
            opener: function (element) {
                return element.find('.item-img');
            }
        }
    });

    $wrapper.find('.js-validation').validate();
    $wrapper.find('.form-filtering').FormFiltering();
    $wrapper.find('.panel-collapsible').panelCollapsible();
    $wrapper.find('.preview-tooltip').previewTooltip();
    $wrapper.find('.gdpr-agreem').gdprAgreem();
}

//nemohu pouzit ready, proto v inpage to nezafunguje
$(document).bind('pageLoaded', function () {
    initialize($('body'));
});
